export enum LoanOfficerTypes {
  MANAGER = 'Manager',
}
